import { NO_LINK_VALUE, type FieldKey } from "./qualificationLinkState";

export const FIELD_LABEL_ID: Record<FieldKey, string> = {
  lb: "licensureBody",
  ab: "accreditationBody",
  sa: "submissionAuthority",
};

// The sentinel stands for "this link has no value in that field". Every surface showing a
// link value goes through here so none of them renders the raw placeholder.
export const displayLinkValue = (
  value: string,
  t: (descriptor: { id: string }) => string,
) => (value === NO_LINK_VALUE ? t({ id: "noneLabel" }) : value);
